import { OfferData, OfferDataForPublisherEvent } from '@/lib/types';
import { isOfferInStoreCatalog } from '@/lib/utils';

interface IGetShouldDisplayCheckoutParams {
  selectedOffer: OfferData | null | string | undefined;
  showPaymentModal: boolean | undefined;
  campaignOfferData: OfferDataForPublisherEvent | undefined;
  activeOrderId: string | undefined;
  catalogOffers: Parameters<typeof isOfferInStoreCatalog>[0];
}

export const getShouldDisplayCheckout = ({
  selectedOffer,
  showPaymentModal,
  campaignOfferData,
  activeOrderId,
  catalogOffers,
}: IGetShouldDisplayCheckoutParams): boolean => {
  if (activeOrderId || campaignOfferData) {
    return true;
  }

  if (!selectedOffer || !showPaymentModal) {
    return false;
  }

  if (typeof selectedOffer === 'string') {
    return true;
  }

  const offerId = selectedOffer.offerId;

  if (!offerId || !catalogOffers) {
    return true;
  }

  return isOfferInStoreCatalog(catalogOffers, offerId);
};
